import React, { useEffect, useState } from "react";
import AddTeam from "./AddTeam";
// import AddEmergencyContact from "./AddEmergencyContact";
// import TeamService from "./TeamService";
import { useDispatch, useSelector } from "react-redux";
// import { ArrowRight } from "feather-icons-react/build/IconComponents";
import { setTeamValue } from "../../../core/redux/action";
import withReactContent from "sweetalert2-react-content";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { Link, useLocation, useParams } from "react-router-dom";
import apiHandler from "../../common/api";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import { TeamData } from "../../../core/json/Team_Data";
import { isValidAustralianPhoneNumber } from "../../common/common";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

const ManageTeam = ({ isDisable = false }) => {
  const params = useParams();
  const route = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const parts = location.pathname;
  let pathname = parts?.trim()?.split("/");

  // const TeamMember = ["Profile", "Emergency Contact", "Service"];
  const [selectedItem, setSelectedItem] = useState("Profile");
  console.log(setSelectedItem, "setSelectedItem");
  const dispatch = useDispatch();
  const TeamFormValue = useSelector((state) => state.TeamValue);
  const user_data = useSelector((state) => state.user_data);
  console.log(TeamFormValue, "410501TeamValue");
  const MySwal = withReactContent(Swal);
  console.log(params, "check params");

  const [uploadFile, setUploadFile] = useState(null);
  const [loading, setLoading] = useState(false);

  console.log(uploadFile, "<==uploadFile");
const handleTeamChangeFile = (file) => {
  console.log(file, "check file 65454545");
  setUploadFile(file);
};


  const HandleTeamSubmit = async (e) => {
    e.preventDefault();
   
    if (
      TeamFormValue?.FirstName == "" ||
      TeamFormValue?.Email == "" ||
      (TeamFormValue?.ContactNumber &&
        !isValidAustralianPhoneNumber(TeamFormValue?.ContactNumber)) ||
      TeamFormValue?.RoleID == 0 ||
      TeamFormValue?.PassWord == "" ||
      TeamFormValue?.PassWord !== TeamFormValue.ConformPassword
    ) {
      let message = "";
      if (TeamFormValue?.FirstName == "") {
        message = " Please Enter Full Name  ";
      } else if (TeamFormValue?.Email == "") {
        message = " Please select Email  ";
      } else if (
        TeamFormValue?.ContactNumber &&
        !isValidAustralianPhoneNumber(TeamFormValue?.ContactNumber)
      ) {
        message = ` ${TeamFormValue?.ContactNumberError} `;
      } else if (TeamFormValue?.RoleID == 0) {
        message = " Please select RoleID ";
      } else if (TeamFormValue?.PassWord == "") {
        message = " Please Enter Valid  PassWord  ";
      } else if (TeamFormValue?.PassWord !== TeamFormValue.ConformPassword) {
        message = " Password and Confirm Password Must Be same   ";
      }

      Swal.fire({
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    let Emergencydata = {};
    Emergencydata.emergencyXml = TeamFormValue.EmergencyContact;
    let EmergencydataString = JSON.stringify(Emergencydata);
    let filterservice = TeamFormValue.Serviceandcommision?.filter(
      (el) => el.Ischecked == true
    );

    let ServiceData = {};
    ServiceData.serviceXml = filterservice;
    let ServiceDataString = JSON.stringify(ServiceData);
    
     setLoading(true);
    const response = await apiHandler({
      method: "POST",
      route: "Business/businessTeamUpsert",
      payload: {
        ...TeamFormValue,
        BusinessId: user_data.businessId,
        BusinessUniqueName: user_data.businessUniqueName,
        loginuserid: user_data.id,
        files: uploadFile,
        EmergencyContact: EmergencydataString,
        Serviceandcommision: ServiceDataString,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      MySwal.fire({
        // title: "Upsert!",
        // text: "Your file has been Upsert.",
        title: params.ID > 0 ? "Team Updated!" : "Team Added!",
        text: params.ID > 0 ? "The Team details have been successfully updated." : "The Team has been successfully added.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(setTeamValue(TeamData));
          navigate(route.StaffListing);
        }
      });
      // navigate(route.BusinessListingMaster);
    } else if (
  response.ResponseCode === "ERROR" &&
  Array.isArray(response.ResponseID) &&
  response.ResponseID.length > 0 &&
  response.ResponseID[0].ID === -4
) {
  // Handle duplicate email error
  Swal.fire({
    icon: "error",
    title: "Duplicate Email",
    text: `The email ${response.ResponseID[0].DuplicateEmail} is already in use. You Cant't use this email`,
    confirmButtonText: "OK",
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });

} 
     else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `${response.ResponseMessage}`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
    setLoading(false);
  };

  console.log(route, "route.teamList");
  const fetchServiceData = async () => {
    try {
      const serviceData = await apiHandler({
        method: "GET",
        route: `Business/TeamserviceData?BusinessID=${user_data.businessId}`,
      });

      if (serviceData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", serviceData);
        return;
      }

      let Teamdata = serviceData?.ResponseData?.map((el) => ({
        ...el,
        Ischecked: true,
        serviceId: el.serviceId,
        ID: 0,
      }));

      if (params.ID) {
        dispatch(
          setTeamValue({
            ...TeamFormValue,
            Serviceandcommision: Teamdata,
          })
        );
      } else {
        dispatch(
          setTeamValue({
            ...TeamData,
            Serviceandcommision: Teamdata,
          })
        );
      }
      console.log(pathname[1], params.ID, "412563");
      if (params.ID > 0) {
        const findByIdResponse = await apiHandler({
          method: "GET",
          route: `Business/TeamfindbyID?ID=${params.ID}`,
        });

        if (findByIdResponse?.ResponseCode !== "SUCCESS") {
          console.error("Failed to fetch service details:", findByIdResponse);
          return;
        }

        const basicDetails =
          findByIdResponse?.ResponseData?.Teamdata?.[0] || {};
        const EmergencyContact =
          findByIdResponse?.ResponseData?.EmergencyContact || [];

        const teamData = findByIdResponse?.ResponseData?.Service || [];

        let teamMap = {};
        teamData.forEach((team) => {
          teamMap[team?.serviceId] = {
            ID: team?.ID,
            staffCommision: team?.staffCommision,
            homeServicePrice: team?.homeServicePrice || "",
          };
        });

        let Teamdata = serviceData?.ResponseData?.map((el) => ({
          ...el,
          category: el?.category,
          name: el?.name,
          price: el?.price,
          duration: el?.duration,
          priceType: el?.priceType,
          Ischecked: teamMap[el.serviceId]?.ID > 0,
          serviceId: el.serviceId,
          ID: teamMap[el.serviceId]?.ID || 0,
          commission: teamMap[el?.serviceId]?.staffCommision,
          homeServicePrice: teamMap[el?.serviceId]?.homeServicePrice,
          
        }));

        const updatedServiceValue = {
          profile: basicDetails?.image,
          FirstName: basicDetails?.fullName,
          LastName: "",
          // LastName: basicDetails?.fullName,
          Email: basicDetails?.email,
          PassWord: basicDetails?.passwordHash,
          ConformPassword: basicDetails?.passwordHash,
          ContactNumber: basicDetails?.phoneNumber,
          RoleID: basicDetails?.roleID,
          designation: basicDetails?.designation,
          CalendorColorID: basicDetails?.calendarcolor,
          Address1: basicDetails?.add1,
          Address2: basicDetails?.add2,
          Country: basicDetails?.country,
          State: basicDetails?.state,
          City: basicDetails?.city,
          ZipCode: basicDetails?.zipcode,
          ID: basicDetails?.id,
          isEmialChange: 0,
          EmergencyContact: EmergencyContact.map((el) => ({
            fullName: el.fullName,
            email: el.email,
            relationship: el.relation,
            phoneNumber: el.phoneNumber,
            Id: el.ID,
          })),
          Serviceandcommision: Teamdata,
        };
        console.log(updatedServiceValue, "databasic");
        dispatch(setTeamValue(updatedServiceValue));
      }
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  useEffect(() => {
    console.log("hit use effect ");
    fetchServiceData();
    console.log("hit use effect 1");
  }, []);

  return (
    <>
     <LoadingSpinner isLoading={loading} />
    <div>
      {selectedItem === "Profile" && (
   <AddTeam
  isDisable={isDisable}
  staffId={params.ID || 0}
  handleChangeFile={handleTeamChangeFile} // ✅ make sure prop name matches exactly
/>

      )}
      {isDisable == false && (
        <div className="col-md-12 p-4 d-flex justify-content-end">
          <button
            onClick={() => navigate("/teamList")}
            className="btn btn-primary btn-md btn-wave me-2"
          >
            Cancel
          </button>
          <button
            onClick={HandleTeamSubmit}
            className="btn btn-outline-primary btn-md me-2"
          >
            Save
            {/* <ArrowRight /> */}
          </button>
        </div>
      )}
    </div>
    </>
  );
};
export default ManageTeam;